import type { TierIIExclusion } from '../types/exclusions.ts';

/** The chemical or product an exclusion is primarily about. */
export function exclusionSubject(exclusion: TierIIExclusion): string {
  return exclusion.kind === 'product_exemption' ? exclusion.productName : exclusion.chemicalName;
}
